import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=7cb2a1f6"
import script from "./LinkCard.vue?vue&type=script&lang=ts"
export * from "./LinkCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports